export function initDropdown() {
  const dropdownContainer = document;

  function toggleDropdown(trigger) {
    const dropdownMenu = trigger.querySelector(".dropdown");
    const isOpen = trigger.classList.contains("isActive");

    closeAllDropdowns();

    if (!isOpen) {
      trigger.classList.add("isActive");
      if (dropdownMenu) {
        dropdownMenu.classList.add("isOpen");
      }
    }
  }

  function closeAllDropdowns() {
    const dropdownTriggers = document.querySelectorAll(".hasDropdown");
    dropdownTriggers.forEach((trig) => {
      trig.classList.remove("isActive");
      const dropdown = trig.querySelector(".dropdown");
      if (dropdown) {
        dropdown.classList.remove("isOpen");
      }
    });
  }

  function clickOutside(event) {
    const isDropdownClick = event.target.closest(".hasDropdown");
    if (!isDropdownClick) {
      closeAllDropdowns();
    }
  }

  dropdownContainer.addEventListener("click", function (event) {
    const trigger = event.target.closest(".hasDropdown");

    if (trigger) {
      event.stopPropagation();
      toggleDropdown(trigger);
    }
  });

  document.addEventListener("click", clickOutside);
}
